import { render, staticRenderFns } from "./batchAddMember.vue?vue&type=template&id=620263a4&scoped=true"
import script from "./batchAddMember.vue?vue&type=script&lang=js"
export * from "./batchAddMember.vue?vue&type=script&lang=js"
import style0 from "./batchAddMember.vue?vue&type=style&index=0&id=620263a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620263a4",
  null
  
)

export default component.exports